export default __webpack_public_path__ + "static/media/temp.5d26647c.svg";